(function () {
  if (customElements.get('nn-mobile-nav')) return;

  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  class NnMobileNav extends HTMLElement {
    constructor() {
      super();
      this._onKeydown = this._onKeydown.bind(this);
      this._onBackdropClick = this._onBackdropClick.bind(this);
      this._onLinkClick = this._onLinkClick.bind(this);
    }

    connectedCallback() {
      this.setAttribute('aria-hidden', 'true');

      const toggleId = this.id;
      this._toggle = document.querySelector(
        '[data-nn-menu-toggle][aria-controls="' + toggleId + '"]'
      );

      if (this._toggle) {
        this._toggle.addEventListener('click', () => this.toggle());
      }

      const backdrop = this.querySelector('[data-nn-mobile-nav-close]');
      if (backdrop) backdrop.addEventListener('click', this._onBackdropClick);

      this.querySelectorAll('a').forEach((a) =>
        a.addEventListener('click', this._onLinkClick)
      );
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
    }

    toggle() {
      if (this.getAttribute('aria-hidden') === 'false') {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.setAttribute('aria-hidden', 'false');
      if (this._toggle) {
        this._toggle.setAttribute('aria-expanded', 'true');
        this._toggle.setAttribute('aria-label', 'Close menu');
      }
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKeydown);

      const first = this.querySelector(FOCUSABLE_SELECTOR);
      if (first) requestAnimationFrame(() => first.focus());

      this.dispatchEvent(
        new CustomEvent('nn:mobile-nav:open', { bubbles: true })
      );
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      if (this._toggle) {
        this._toggle.setAttribute('aria-expanded', 'false');
        this._toggle.setAttribute('aria-label', 'Open menu');
        this._toggle.focus();
      }
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKeydown);

      this.dispatchEvent(
        new CustomEvent('nn:mobile-nav:close', { bubbles: true })
      );
    }

    _onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = Array.from(
        this.querySelectorAll(FOCUSABLE_SELECTOR)
      ).filter((el) => !el.hasAttribute('disabled'));
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }

    _onBackdropClick() {
      this.close();
    }

    _onLinkClick() {
      this.close();
    }
  }

  customElements.define('nn-mobile-nav', NnMobileNav);

  document.addEventListener('DOMContentLoaded', initStickyHeader);
  if (document.readyState !== 'loading') initStickyHeader();

  function initStickyHeader() {
    const wrap = document.querySelector('[data-nn-header]');
    if (!wrap) return;
    if (
      !wrap.classList.contains('is-sticky-always') &&
      !wrap.classList.contains('is-sticky-scroll-up')
    ) {
      return;
    }
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      wrap.classList.toggle('is-scrolled', y > 8);

      if (wrap.classList.contains('is-sticky-scroll-up')) {
        if (y > last && y > 80) {
          wrap.classList.add('is-hidden');
        } else {
          wrap.classList.remove('is-hidden');
        }
      }
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
